import React, { useState } from "react";
import { useNavigate } from "react-router-dom"; // Import useNavigate
import { useData } from "../../../DataContext";
import "bootstrap/dist/css/bootstrap.min.css";
import FooterContent from "../footer-content/footer-content.js";
import HeaderContent from "../header-content/header-content.js";
//import "./mrt-home-page.css";

const ErrorPage = () => {
  const navigate = useNavigate();
  const { setTrackingParameters } = useData();

  return (
    <div className="outer-body-container text-02">
    <HeaderContent toDisplayClientLogo={false} currentPage="errorPage" locale="en" countryCode="gb"/>

    <div className="body-content">
      {/* <div className="column-left"></div> */}
      <div className="box column-middle">
        <div className="contentbody">
          <p className="color-red sorry-text">
            Sorry!
          </p>
          <div style={{ borderBottom: '2px solid black', margin: '10px 0', marginRight: '90%' }} />
          <p className="top-gap" style={{fontSize: '20px', fontFamily: '300'}}>
          Unfortunately, the page does not exist. Please check the URL or return to the <a href="/">home page</a>.
          .</p>
        </div>
      </div>
      {/* <div className="column-left"></div> */}
    </div>

    <FooterContent />
  </div>    
  );
};

export default ErrorPage;
